import { render } from "./ConsultarCartasProposta.vue?vue&type=template&id=342f85f4&scoped=true"
import script from "./ConsultarCartasProposta.vue?vue&type=script&lang=js"
export * from "./ConsultarCartasProposta.vue?vue&type=script&lang=js"

import "./ConsultarCartasProposta.vue?vue&type=style&index=0&id=342f85f4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-342f85f4"]])

export default __exports__